<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="DB Menos Administrador"
      title="DB Menos">
      <template slot="links">
        <sidebar-item v-if="getRole() !== 'finamigo'" :link="{name: 'Chat', icon: 'fas fa-comment-dots text-gray', path: '/chat'}"/>
        <sidebar-item v-if="getRole() !== 'finamigo'" :link="{name: 'Dashboard',icon: 'ni ni-tv-2 text-gray',path: '/dashboard'}"/>
        <sidebar-item v-if="(getRole() === 'admin' || getRole() === 'manager_service' || getRole() === 'manager_seller')" :link="{name: 'Actividades',icon: 'fas fa-tasks text-gray',path: '/activity'}"/>
        <sidebar-item v-if="getRole() !== 'service' && getRole() !== 'finamigo' && getRole() !== 'manager_service'" :link="{name: 'Prospectos', icon: 'fas fa-users text-gray', path: '/leads'}"/>
        <sidebar-item v-if="getRole() !== 'finamigo'" :link="{name: 'Clientes', icon: 'fas fa-user-friends text-gray', path: '/clients'}"/>
        <sidebar-item v-if="getRole() === 'admin' || getRole() === 'manager_service' || getRole() === 'manager_seller' || getRole() === 'service'" :link="{name: 'Nuevos clientes', icon: 'fas fa-user-plus text-gray', path: '/newUsers'}"/>
        <sidebar-item v-if="getRole() === 'admin' || getRole() === 'manager_service' || getRole() === 'manager_seller'" :link="{name: 'Proyección DBMenos', icon: 'fas fa-chart-line text-gray', path: '/projections'}"/>
        <sidebar-item v-if="getRole() !== 'finamigo' && getRole() !== 'manager_service'" :link="{name: 'Historial', icon: 'fas fa-history text-gray', path: '/history'}"/>
        <sidebar-item v-if="(getRole() === 'admin' || getRole() === 'manager_service' || getRole() === 'manager_seller') && user.view_only === 0" :link="{name: 'Reportes de crédito', icon: 'fas fa-file-invoice text-gray', path: '/creditReports'}"/>
        <sidebar-item v-if="getRole() !== 'seller' && getRole() !== 'finamigo' && getRole() !== 'manager_seller' && user.view_only === 0" :link="{name: 'Editor de cuentas', icon: 'fas fa-file-invoice-dollar text-gray', path: '/accountEditor'}"/>
        <sidebar-item v-if="getRole() !== 'seller' && getRole() !== 'finamigo' && getRole() !== 'manager_seller' && user.view_only === 0" :link="{name: 'Editor de comisiones', icon: 'fas fa-search-dollar text-gray', path: '/commissionEditor'}"/>
        <sidebar-item v-if="getRole() === 'finamigo' && user.view_only === 0" :link="{name: 'Finamigo', icon: 'far fa-grin text-gray', path: '/finamigoView'}"/>
        <sidebar-item v-if="getRole() !== 'seller' && getRole() !== 'manager_seller' && getRole() !== 'finamigo' && user.view_only === 0" :link="{name: 'Saldos Finamigo', icon: 'far fa-credit-card text-gray', path: '/balanceVisor'}"/>
        <sidebar-item v-if="getRole() === 'admin' && getRole() !== 'manager_service' && user.view_only === 0" :link="{name: 'Consultores', icon: 'fas fa-headset text-gray', path: '/consultants'}"/>
        <sidebar-item v-if="(getRole() === 'admin' || getRole() === 'manager_service') && user.view_only === 0" :link="{name: 'Cargas masivas', icon: 'fas fa-upload text-gray', path: '/massiveLoads'}"/>
        <sidebar-item v-if="getRole() === 'admin' && user.view_only === 0" :link="{name: 'Blog', icon: 'fas fa-rss text-gray', path: '/blogEntries'}"/>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar :isChat="isChat"></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="400" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter && !isChat"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    computed: {
      user() { return JSON.parse(localStorage.getItem(this.$v.STORE_KEYS.USER)) }
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
        isChat: this.$route.path === '/chat'
      };
    },
    watch: {
      $route(){
        this.isChat = this.$route.path === '/chat'
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      getRole() {
        if (this.user) return this.user.role
        this.$router.push("/login")
      }
    }
  };
</script>
<style lang="scss">
</style>
